export default __webpack_public_path__ + "static/media/sister-vbgi.bb165a60.png";